// GA custom events
$('[data-ga-category][data-ga-action]').on('click', (event) => {
  const $target = $(event.target);
  ga(
    'send',
    'event',
    $target.data('ga-category'),
    $target.data('ga-action'),
    $target.data('ga-label'),
    $target.data('ga-value')
  );
});

$('.wpcf7-form').on(
  'wpcf7mailsent',
  (event) => {
    ga('send', 'event', 'Formulaire', 'Envoi', event.target.id);
  },
  false
);
